import { render } from "./LeaveAttachmentModal.vue?vue&type=template&id=70e32f63&scoped=true"
import script from "./LeaveAttachmentModal.vue?vue&type=script&lang=js"
export * from "./LeaveAttachmentModal.vue?vue&type=script&lang=js"

import "./LeaveAttachmentModal.vue?vue&type=style&index=0&id=70e32f63&lang=scss&scoped=true"

import exportComponent from "C:\\laragon\\www\\hr\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70e32f63"]])

export default __exports__